import { gql } from '@apollo/client';

export const SessionQueryGql = gql`
  query SessionQuery {
    session
  }
`;
